import {combineReducers} from 'redux';
import questionReducer from './questionReducer';
import dialogueReducer from "./dialogueReducer";


const rootReducer = combineReducers({
    questionReducer: questionReducer,
    dialogueReducer: dialogueReducer
})
export default rootReducer;
//export type RootState = ReturnType<typeof rootReducer>
